var React = require('react');

function AngleUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M136.5 185.1l116 117.8c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L128 224.7 27.6 326.9c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l116-117.8c4.7-4.6 12.3-4.6 17 .1z"}));
}

AngleUp.defaultProps = {"viewBox":"0 0 256 512"};

module.exports = AngleUp;

AngleUp.default = AngleUp;
